import {
  API_KEY_SERVICE_BASE_URL,
  OauthClient,
} from '@rhapsody/ngx-api-key-client';
import {
  ApplicationConfig,
  InjectionToken,
  provideZoneChangeDetection,
} from '@angular/core';
import { AuthInterceptor, authConfig } from '@core/auth';
import {
  HTTP_INTERCEPTORS,
  provideHttpClient,
  withInterceptorsFromDi,
} from '@angular/common/http';

import { KeyService } from '@core/services/key.service';
import { environment } from '../environments/environment';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { provideAuth } from 'angular-auth-oidc-client';
import { provideRouter } from '@angular/router';
import { routes } from './app.routes';

export const DEBUG_TOOLS = new InjectionToken<boolean>('Debug Tools');

function getBaseUrl(): string {
  return environment.apiKeyUrl;
}

function showDebugTools(): boolean {
  return environment.showDebugTools;
}

export const appConfig: ApplicationConfig = {
  providers: [
    provideHttpClient(withInterceptorsFromDi()),
    { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true },
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes),
    provideAuth(authConfig),
    OauthClient,
    KeyService,
    { provide: API_KEY_SERVICE_BASE_URL, useFactory: getBaseUrl },
    { provide: DEBUG_TOOLS, useFactory: showDebugTools },
    provideAnimationsAsync(),
  ],
};
